import * as constants from './constants';

export const getDeterminantTypes = payload => ({
    type: constants.getDeterminantTypes.toString(),
    payload
});

export const clearDeterminantTypes = payload => ({
    type: constants.clearDeterminantTypes.toString()
});